var _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.9996 57C94.9996 36.5655 78.4342 20 57.9996 20",
    stroke: "#FCE80F",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9996 94C78.4342 94 94.9996 77.4345 94.9996 57",
    stroke: "#FF6633",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9996 57C20.9996 77.4345 37.5651 94 57.9996 94",
    stroke: "#28DDCF",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9996 20C37.5651 20 20.9996 36.5655 20.9996 57",
    stroke: "#764AFF",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1265 63.2C52.9265 63.2 51.0864 61.34 51.0864 58.62V58.3H53.3665V58.58C53.3665 60.34 54.0865 61.16 57.0465 61.16C59.8265 61.16 60.8265 60.52 60.8265 58.94C60.8265 57.58 59.9065 56.96 58.2265 56.96H54.4865V55.16H57.9265C59.5465 55.16 60.3865 54.56 60.3865 53.36C60.3865 52.06 59.5865 51.44 56.9865 51.44C54.2465 51.44 53.3665 52.26 53.3665 54.02V54.16H51.0864V53.98C51.0864 51.36 53.0064 49.4 57.1665 49.4C60.5865 49.4 62.5265 50.66 62.5265 52.94C62.5265 54.46 61.6265 55.54 59.9065 55.82V55.98C61.8465 56.32 63.0065 57.4 63.0065 59.26C63.0065 61.8 60.7865 63.2 57.1265 63.2Z",
    fill: "#09041C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 56.5,
    stroke: "#DDDFE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber3);
export default __webpack_public_path__ + "static/media/number-3.c95d1d66d57635517ef5c9bef4f57d56.svg";
export { ForwardRef as ReactComponent };